export const LOADING_TEXT = "Загрузка..."
export const COURIERS_DO_NOT_EXIST_TEXT = "Нет курьеров"
export const ORDERS_DO_NOT_EXIST_TEXT = "Нет заказов"
export const MINUTE = "мин"

export const LOGISTICS_TEXT = "Логистика"
export const COURIERS_TEXT = "Курьеры"
export const ORDERS_TEXT = "Заказы"
export const FREE_TEXT = "Свободные"
export const FREE_COURIER_TEXT = "Свободен"
export const ON_WAY_TEXT = "В пути"
export const RETURNING_TEXT = "Возвращаются"
export const DELAYED_ORDER_TEXT = "Отложенные заказы"
export const WAITING_TEXT = "В ожидание"
export const DELAYED_TEXT = "Отложен"
export const CHECKED_TEXT = "Проверено"
export const COLLAPSE_TEXT = "Свернуть"
export const CLEAR_TEXT = "Очистить"
export const ASSIGN_TEXT = "Назначить"
export const TOOK_TEXT = "Взято"
export const ORDER_NUMBERED_TEXT="Заказ № "
export const N_FREE_COURIERS_TEXT=" свободных курьеров"
export const N_ON_WAY_COURIERS_TEXT=" курьера в пути"
export const N_RETURNING_COURIERS_TEXT=" курьера возращаютця"

export const ORDER_BLOCK_ASSIGN_CHOOSE_ORDER_TEXT="Выберите заказы, для того, чтобы назначить курьера"
export const ORDER_BLOCK_ASSIGN_CHOOSE_COURIER_TEXT="Назначить курьеру заказ для доставки: "
export const ASSIGN_BLOCK_TITLE_TEXT = "Назначенные"
export const ASSIGN_MODAL_SELECT_COURIER_TEXT = "Выберите курьера"
export const ORDER_SUCCESSFULLY_ASSIGNED_TEXT = "Заказ успешно назначен!"
export const NOT_TEXT = "Нету"
export const OK_TEXT = "ОК"
export const CANCEL_TEXT = "Отмена"
export const CANCEL_SENDING_TEXT = "Отменить отправку"
export const CANCEL_ASSIGN_TEXT = "Отменить назначение"
export const SEND_ORDERS_TEXT = "Отправить заказ(ы)"

export const COURIER_STATUS_FREE_TEXT = "Свободен"
export const COURIER_STATUS_ON_WAY_TEXT = "В пути"
export const COURIER_STATUS_RETURNING_TEXT = "Возращается"
export const COURIER_STATUS_NOT_WORKING_TEXT = "Не работает"
export const COURIER_STATUS_NOT_FOUND_TEXT = "Не найдено"

export const WARNING_SIGN_OUT_TEXT = "Вы действительно хотите выйти?"

export const CHANGE_BRANCH_MODAL_TITLE_TEXT = "Изменить организацию"
export const CHANGE_TEXT = "Изменить"
export const CANCEL_ASSIGN_SUCCESS_TEXT="Отправка успешно отменена"
export const CANCEL_ASSIGN_ERROR_TEXT="Ошибка при отмене отправки!"
export const SEND_ON_WAY_SUCCESS_TEXT="Курьер успешно отправлен"
export const ERROR_TEXT="Произошла ошибка! Пожалуйста, попробуйте позднее!"
